import React, { useState, useEffect } from "react";
import VideoModal from "../components/VideoModal";
import "../styles/Pages.css";
import { getQuotesByMonthDay } from "../data/quotesUtil";
import { getPravachanByMonthDay } from "../data/pravachanUtil";

// import { getAchamanByMonthDayAll } from "../data/achamanUtil";

function Calendar2026() {
  const [calendarData, setCalendarData] = useState({});
  const [festivalData, setFestivalData] = useState({});
  const [tithiData, setTithiData] = useState([]);
  const [gujMonthData, setGujMonthData] = useState([]);
  const [imagesData, setImagesData] = useState({});
  const [videoData, setVideoData] = useState({});
  const [, setVicharanData] = useState({});
  const [prasangData, setPrasangData] = useState({});
  // const [selectedVicharanDate, setSelectedVicharanDate] = useState(null);
  const [selectedPrasangDate, setSelectedPrasangDate] = useState(null);
  const [selectedPrasangIndex, setSelectedPrasangIndex] = useState(0);
  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);
  const [selectedVideoId, setSelectedVideoId] = useState(null);
  const [selectedVideoTitle, setSelectedVideoTitle] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(
    () => new Date().getMonth() + 1,
  );
  const [selectedYear] = useState(2026);
  const [loading, setLoading] = useState(true);
  const [quotesByDate, setQuotesByDate] = useState({});
  const [selectedQuote, setSelectedQuote] = useState(null);
  const [pravachanByDate, setPravachanByDate] = useState({});
  const [selectedPravachan, setSelectedPravachan] = useState(null);

  useEffect(() => {
    if (!selectedPrasangDate && !selectedQuote && !selectedPravachan) {
      return undefined;
    }

    const previousHtmlOverflow = document.documentElement.style.overflow;
    const previousBodyOverflow = document.body.style.overflow;
    document.documentElement.style.overflow = "hidden";
    document.body.style.overflow = "hidden";

    return () => {
      document.documentElement.style.overflow = previousHtmlOverflow;
      document.body.style.overflow = previousBodyOverflow;
    };
  }, [selectedPrasangDate, selectedPravachan, selectedQuote]);

  // const [achamanModal, setAchamanModal] = useState(null);
  // const [achamanByDate, setAchamanByDate] = useState({});

  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const dayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  useEffect(() => {
    let isMounted = true;

    // Load quotes.json and group by MM-DD
    const loadQuotes = async () => {
      try {
        const res = await fetch("/data/quotes.json");
        if (!res.ok) throw new Error("Failed to load quotes.json");
        const quotes = await res.json();
        const grouped = getQuotesByMonthDay(quotes);
        if (isMounted) setQuotesByDate(grouped);
      } catch (e) {
        console.error("Error loading quotes.json", e);
      }
    };

    const loadVideoData = async () => {
      if (!isMounted) return;

      const targetUrls = [
        "https://hariprabodham.org.in/api/?category=1",
        "https://hariprabodham.org.in/api/?category=10",
        "https://hariprabodham.org.in/api/?category=11",
        "https://hariprabodham.org.in/api/?category=12",
      ];

      // Fallback URLs for different CORS proxies
      const fallbackMethods = [
        {
          name: "Direct Proxy",
          urls: targetUrls,
        },
        {
          name: "JSONP Proxy",
          urls: [
            "https://api.allorigins.win/raw?url=https://hariprabodham.org.in/api/?category=1",
            "https://api.allorigins.win/raw?url=https://hariprabodham.org.in/api/?category=10",
            "https://api.allorigins.win/raw?url=https://hariprabodham.org.in/api/?category=11",
            "https://api.allorigins.win/raw?url=https://hariprabodham.org.in/api/?category=12",
          ],
        },
        {
          name: "Alternative Proxy",
          urls: [
            "https://cors-proxy.htmldriven.com/?url=http://dbphp.prabodhswamiji.in/dbihariprabodham.php?category=1",
            "https://cors-proxy.htmldriven.com/?url=http://dbphp.prabodhswamiji.in/dbihariprabodham.php?category=10",
            "https://cors-proxy.htmldriven.com/?url=http://dbphp.prabodhswamiji.in/dbihariprabodham.php?category=11",
            "https://cors-proxy.htmldriven.com/?url=http://dbphp.prabodhswamiji.in/dbihariprabodham.php?category=12",
          ],
        },
      ];

      let allVideos = [];
      let successfulMethod = null;

      for (const method of fallbackMethods) {
        try {
          console.log(`Trying method: ${method.name}`);

          const responses = await Promise.all(
            method.urls.map(async (url) => {
              try {
                const response = await fetch(url, {
                  method: "GET",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  mode: "cors",
                });
                return response;
              } catch (fetchError) {
                console.warn(`Failed to fetch ${url}:`, fetchError);
                return null;
              }
            }),
          );

          // Filter out failed responses
          const validResponses = responses.filter(
            (response) => response && response.ok,
          );

          if (validResponses.length === 0) {
            console.log(`No valid responses from ${method.name}`);
            continue;
          }

          console.log(
            `Got ${validResponses.length} valid responses from ${method.name}`,
          );

          const dataPromises = validResponses.map(async (response) => {
            try {
              const text = await response.text();
              // Try to parse as JSON
              return JSON.parse(text);
            } catch (parseError) {
              console.warn("Parse error:", parseError);
              return [];
            }
          });

          const allData = await Promise.all(dataPromises);
          console.log(`Raw API responses from ${method.name}:`, allData);

          // Parse and combine videos from all sources
          allVideos = [];
          allData.forEach((videos, index) => {
            if (Array.isArray(videos) && videos.length > 0) {
              console.log(
                `Parsed ${videos.length} videos from category ${index === 0 ? "1" : index === 1 ? "10" : index === 2 ? "11" : "12"}:`,
              );
              allVideos = allVideos.concat(videos);
            }
          });

          if (allVideos.length > 0) {
            console.log(
              `Successfully loaded ${allVideos.length} videos using ${method.name}`,
            );
            successfulMethod = method.name;
            break;
          }
        } catch (error) {
          console.error(`Error with ${method.name}:`, error);
          continue;
        }
      }

      if (!successfulMethod || allVideos.length === 0) {
        console.error("All methods failed to load video data");
        // Set some mock data for development
        console.log("Setting empty video data...");
        if (isMounted) {
          setVideoData({});
        }
        return;
      }

      // Group videos by month and day
      const videosByDate = {};
      allVideos.forEach((video) => {
        if (video.InfoDay && video.InfoMonth) {
          const key = `${video.InfoDay}-${video.InfoMonth}`;
          if (!videosByDate[key]) {
            videosByDate[key] = [];
          }
          videosByDate[key].push(video);
        }
      });

      if (isMounted) {
        setVideoData(videosByDate);
        console.log(
          `Video data loaded successfully using ${successfulMethod}:`,
          Object.keys(videosByDate).length,
          "dates have videos",
        );
      }
    };

    const loadPravachan = async () => {
      try {
        const res = await fetch(
          "https://withered-sound-8cec.akshar369.workers.dev/?endpoint=pravachan",
        );
        if (!res.ok) throw new Error("Failed to load pravachan");
        const data = await res.json();
        setPravachanByDate(getPravachanByMonthDay(data));
      } catch (e) {
        console.error("Error loading pravachan", e);
      }
    };

    const loadVicharanData = async () => {
      if (!isMounted) return;

      try {
        console.log("Starting to load vicharan data...");
        // Try using corsproxy.io (more reliable for large responses)
        const proxyUrl = "https://corsproxy.io/?";
        const targetUrl =
          "https://withered-sound-8cec.akshar369.workers.dev/?endpoint=vicharan";
        //        const response = await fetch(proxyUrl + targetUrl);
        const response = await fetch(targetUrl);

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const vicharans = await response.json();
        console.log("Parsed vicharans:", vicharans);

        // Group vicharans by month and day, filter out invalid entries
        const vicharansByDate = {};
        vicharans.forEach((vicharan) => {
          // Only group if both day and month are valid numbers
          console.log("Processing vicharan:", vicharan);
          const day = vicharan.infoday;
          const month = vicharan.infomonth;
          if (
            typeof day === "number" &&
            !isNaN(day) &&
            typeof month === "number" &&
            !isNaN(month)
          ) {
            const key = `${day}-${month}`;
            if (!vicharansByDate[key]) {
              vicharansByDate[key] = [];
            }
            vicharansByDate[key].push(vicharan);
          }
        });

        if (isMounted) {
          setVicharanData(vicharansByDate);
          console.log("Vicharan data loaded successfully:", vicharansByDate);
        }
      } catch (error) {
        console.error("Error loading vicharan data:", error);
        if (!isMounted) return;
      }
    };

    const loadPrasangData = async () => {
      if (!isMounted) return;

      try {
        const response = await fetch("/data/prasang-index.json");
        if (!response.ok) {
          throw new Error(
            `Failed to load prasang-index.json: ${response.status}`,
          );
        }
        const index = await response.json();
        const prasangsByDate = {};
        index.forEach((prasang) => {
          if (!prasang.engdate) return;
          const [, month, day] = prasang.engdate.split("-");
          const key = `${Number(day)}-${Number(month)}`;
          if (!prasangsByDate[key]) {
            prasangsByDate[key] = [];
          }
          prasangsByDate[key].push({
            ...prasang,
            date: prasang.engdate,
            place: "",
            content: prasang.text,
            subject: "",
            tags: [],
          });
        });

        if (isMounted) {
          setPrasangData(prasangsByDate);
          console.log("Prasang index loaded successfully:", prasangsByDate);
        }
      } catch (error) {
        console.error("Error loading prasang data:", error);
        if (isMounted) {
          setPrasangData({});
        }
      }
    };

    const loadCalendarData = async () => {
      if (!isMounted) return;

      try {
        if (isMounted) setLoading(true);
        console.log("Loading calendar data...");

        // Load all JSON data
        const [calendar, festivals, tithi, gujmonth, images] =
          await Promise.all([
            fetch("/calendar/2026A.json").then((res) => {
              if (!res.ok)
                throw new Error(`Failed to load calendar: ${res.status}`);
              return res.json();
            }),
            fetch("/calendar/festival.json").then((res) => {
              if (!res.ok)
                throw new Error(`Failed to load festivals: ${res.status}`);
              return res.json();
            }),
            fetch("/calendar/tithi.json").then((res) => {
              if (!res.ok)
                throw new Error(`Failed to load tithi: ${res.status}`);
              return res.json();
            }),
            fetch("/calendar/gujmonth.json").then((res) => {
              if (!res.ok)
                throw new Error(`Failed to load gujmonth: ${res.status}`);
              return res.json();
            }),
            fetch("/calendar/images.json").then((res) => {
              if (!res.ok)
                throw new Error(`Failed to load images: ${res.status}`);
              return res.json();
            }),
          ]);

        if (!isMounted) return;

        console.log("Calendar JSON data loaded successfully");
        setCalendarData(calendar);
        setFestivalData(festivals);
        setTithiData(tithi);
        setGujMonthData(gujmonth);
        setImagesData(images);

        // Load video data from API
        await Promise.all([
          loadVideoData(),
          loadVicharanData(),
          loadPrasangData(),
        ]);
        console.log("All data loading completed");
      } catch (error) {
        console.error("Error loading calendar data:", error);
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    loadCalendarData();
    loadQuotes();
    loadPravachan();
    // setAchamanByDate(getAchamanByMonthDayAll());

    return () => {
      isMounted = false;
    };
  }, []);

  const getDaysInMonth = (year, month) => {
    return new Date(year, month, 0).getDate();
  };

  const getFirstDayOfMonth = (year, month) => {
    return new Date(year, month - 1, 1).getDay();
  };

  const getVideoDataForDate = (date, month) => {
    const key = `${date}-${month}`;
    return videoData[key] || [];
  };

  // const getVicharanDataForDate = (date, month) => {
  //   const key = `${date}-${month}`;
  //   return vicharanData[key] || [];
  // };

  const getPrasangDataForDate = (date, month) => {
    const key = `${date}-${month}`;
    return prasangData[key] || [];
  };

  const getDateKey = (date) => {
    return `${date}-${selectedMonth}-${selectedYear}`;
  };

  const openVideoModal = (videoUrl, title) => {
    console.log("Opening video modal with:");
    console.log("Original video URL:", videoUrl);
    console.log("Video Title:", title);

    // Extract video ID from YouTube URL like in AksharVani
    let videoId = "";

    if (!videoUrl) {
      console.error("No video URL provided");
      return;
    }

    // Simple extraction like in AksharVani - replace the YouTube watch URL to get just the ID
    if (videoUrl.includes("youtube.com/watch?v=")) {
      videoId = videoUrl.replace("https://www.youtube.com/watch?v=", "");
      // Remove any additional parameters
      if (videoId.includes("&")) {
        videoId = videoId.split("&")[0];
      }
    } else if (videoUrl.includes("youtu.be/")) {
      videoId = videoUrl.split("youtu.be/")[1];
      if (videoId.includes("?")) {
        videoId = videoId.split("?")[0];
      }
    } else {
      // If it's already a video ID or unknown format
      videoId = videoUrl;
    }

    console.log("Extracted video ID:", videoId);
    setSelectedVideoId(videoId);
    setSelectedVideoTitle(title);
    setIsVideoModalOpen(true);
  };

  const closeVideoModal = () => {
    setIsVideoModalOpen(false);
    setSelectedVideoId(null);
    setSelectedVideoTitle(null);
  };

  // function closeAchamanModal() {
  //   setAchamanModal(null);
  // }
  const renderCalendarDays = () => {
    const daysInMonth = getDaysInMonth(selectedYear, selectedMonth);
    const firstDay = getFirstDayOfMonth(selectedYear, selectedMonth);
    const days = [];

    // Add empty cells for days before the first day of the month
    for (let i = 0; i < firstDay; i++) {
      days.push(<div key={`empty-${i}`} className="calendar-day empty"></div>);
    }

    // Add days of the month
    for (let date = 1; date <= daysInMonth; date++) {
      const dateKey = getDateKey(date);
      const dayData = calendarData[dateKey];
      const videosForDate = getVideoDataForDate(date, selectedMonth);
      // const vicharanForDate = getVicharanDataForDate(date, selectedMonth);
      const prasangForDate = getPrasangDataForDate(date, selectedMonth);

      const isToday =
        new Date().getDate() === date &&
        new Date().getMonth() + 1 === selectedMonth &&
        new Date().getFullYear() === selectedYear;

      // Prepare MM-DD key for quotes
      const mm = String(selectedMonth).padStart(2, "0");
      const dd = String(date).padStart(2, "0");
      const quoteKey = `${mm}-${dd}`;
      const quotesForDate = quotesByDate[quoteKey] || [];

      // Prepare MM-DD key for pravachan
      const pravachanKey = `${mm}-${dd}`;
      const pravachanForDate = pravachanByDate[pravachanKey] || [];
      // const achamanKey = `${mm}-${dd}`;
      // const achamanForDate = achamanByDate[achamanKey] || [];

      days.push(
        <div key={date} className={`calendar-day ${isToday ? "today" : ""}`}>
          <div className="date-number">{date}</div>
          {dayData && (
            <div className="day-info">
              {/* Combined Hindu Calendar Info: GujMonth Paksha Tithi */}
              {(dayData.GujMonthId || dayData.PakshaId || dayData.TithiId) && (
                <div
                  className={`hindu-calendar-info ${
                    dayData.FestivalIds &&
                    dayData.FestivalIds.length > 0 &&
                    dayData.FestivalIds.some((festivalId) => {
                      const festival = festivalData[festivalId];
                      return festival && festival.Flag === 1;
                    })
                      ? "public-holiday"
                      : ""
                  }`}
                >
                  {dayData.GujMonthId &&
                    gujMonthData[0] &&
                    gujMonthData[0][dayData.GujMonthId]}{" "}
                  {dayData.PakshaId &&
                    (dayData.PakshaId === "1"
                      ? "Sud"
                      : dayData.PakshaId === "2"
                        ? "Vad"
                        : "")}{" "}
                  {dayData.TithiId &&
                    tithiData[0] &&
                    tithiData[0][dayData.TithiId]}
                </div>
              )}

              {/* Festival information */}
              {dayData.FestivalIds && dayData.FestivalIds.length > 0 && (
                <div className="festivals">
                  {dayData.FestivalIds.map((festivalId, index) => {
                    const festival = festivalData[festivalId];
                    if (festival) {
                      return (
                        <div
                          key={index}
                          className={`festival-item ${
                            parseInt(festivalId) === 215
                              ? "white-festival"
                              : parseInt(festivalId) === 216
                                ? "dark-gray-festival"
                                : festival.Flag === 1
                                  ? "public-holiday-festival"
                                  : festival.Flag === 2
                                    ? "special-festival"
                                    : festival.Flag === 3
                                      ? "gray-festival"
                                      : parseInt(festivalId) >= 66 &&
                                          parseInt(festivalId) <= 89
                                        ? "orange-festival"
                                        : ""
                          }`}
                        >
                          {festival.FestivalImage &&
                            festival.FestivalImage !== 0 &&
                            imagesData[festival.FestivalImage] && (
                              <img
                                src={`/calendar/images/${imagesData[festival.FestivalImage]}`}
                                alt={festival.Festival}
                                className="festival-icon"
                              />
                            )}
                          <span className="festival-name">
                            {festival.Festival}
                          </span>
                        </div>
                      );
                    }
                    return null;
                  })}
                </div>
              )}

              {/* Vicharan display temporarily disabled
              {vicharanForDate.length > 0 && (
                <div className="vicharans">
                  <div className="vicharan-item">
                    <div
                      className="vicharan-link"
                      onClick={() =>
                        setSelectedVicharanDate({
                          date,
                          month: selectedMonth,
                          data: vicharanForDate,
                        })
                      }
                    >
                      <div className="vicharan-info">
                        <span className="vicharan-title">
                          Vicharan ({vicharanForDate.length})
                        </span>

                        <div className="vicharan-details">
                          <small></small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )} */}

              {/* Prasang information */}
              {prasangForDate.length > 0 && (
                <div className="prasangs">
                  <div className="prasang-item">
                    <div
                      className="prasang-link"
                      onClick={() => {
                        setSelectedPrasangIndex(0);
                        setSelectedPrasangDate({
                          date,
                          month: selectedMonth,
                          data: prasangForDate,
                        });
                      }}
                    >
                      <div className="prasang-info">
                        <span className="prasang-title">
                          Prasang ({prasangForDate.length})
                        </span>
                        <div className="prasang-details">
                          <small></small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Video content information */}
              {videosForDate.length > 0 && (
                <div className="videos">
                  {videosForDate.map((video, index) => (
                    <div key={video.InfoId} className="video-item">
                      <div
                        className="video-thumbnail-container"
                        onClick={() =>
                          openVideoModal(video.VideoUrl, video.Title)
                        }
                        role="button"
                        tabIndex={0}
                        onKeyPress={(e) => {
                          if (e.key === "Enter")
                            openVideoModal(video.VideoUrl, video.Title);
                        }}
                      >
                        <img
                          src={
                            video.VideoThumb && video.VideoThumb.trim()
                              ? video.VideoThumb.trim()
                              : "/image/aksharvani.jpg"
                          }
                          alt={video.Title}
                          className="video-thumbnail"
                          style={{
                            filter:
                              !video.VideoThumb || !video.VideoThumb.trim()
                                ? "grayscale(100%)"
                                : undefined,
                          }}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = "/image/aksharvani.jpg";
                            e.target.style.filter = "grayscale(100%)";
                          }}
                        />
                        <div className="video-play-overlay">
                          <svg viewBox="0 0 24 24" fill="currentColor">
                            <path d="M8 5v14l11-7z" />
                          </svg>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {/* Quotes for this date (below video) */}
              {quotesForDate.length > 0 && (
                <div className="calendar-quotes">
                  <button
                    className="calendar-quote-label"
                    style={{
                      background: "#e0fcf7",
                      color: "#12a389",
                      border: "1px solid #f2fefb",
                      borderRadius: "6px",
                      padding: "2px 8px",
                      cursor: "pointer",
                      fontSize: "0.95em",
                      marginTop: "4px",
                      width: "100%",
                      textAlign: "left",
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                      position: "relative",
                    }}
                    title={quotesForDate[0].quote}
                    onClick={() => setSelectedQuote({ all: quotesForDate })}
                  >
                    {quotesForDate[0].quote.length > 30
                      ? quotesForDate[0].quote.slice(0, 30) + "..."
                      : quotesForDate[0].quote}
                    {quotesForDate.length > 1 && (
                      <span
                        style={{
                          background: "#abf6e8",
                          color: "#12a389",
                          borderRadius: "10px",
                          fontSize: "0.8em",
                          padding: "2px 7px",
                          marginLeft: "8px",
                          position: "absolute",
                          right: "1px",
                          top: "1px",
                        }}
                      >
                        {quotesForDate.length}
                      </span>
                    )}
                  </button>
                </div>
              )}

              {/* Pravachan for this date (below quotes) */}
              {pravachanForDate.length > 0 && (
                <div className="calendar-pravachan">
                  <button
                    className="calendar-pravachan-label"
                    style={{
                      background: "#cefbe2",
                      color: "#0c8442",
                      border: "1px solid #a5d6a7",
                      borderRadius: "6px",
                      padding: "2px 8px",
                      cursor: "pointer",
                      fontSize: "0.95em",
                      marginTop: "4px",
                      width: "100%",
                      textAlign: "left",
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                      position: "relative",
                    }}
                    //  title={pravachanForDate[0].PrvTitle}
                    onClick={() =>
                      setSelectedPravachan({ all: pravachanForDate })
                    }
                  >
                    {pravachanForDate[0].PrvTitle.length > 30
                      ? pravachanForDate[0].PrvTitle.slice(0, 30) + "..."
                      : pravachanForDate[0].PrvTitle}
                    {pravachanForDate.length > 1 && (
                      <span
                        style={{
                          background: "#98f6c2",
                          color: "#0c8442",
                          borderRadius: "10px",
                          fontSize: "0.8em",
                          padding: "2px 7px",
                          marginLeft: "8px",
                          position: "absolute",
                          right: "1px",
                          top: "1px",
                        }}
                      >
                        {pravachanForDate.length}
                      </span>
                    )}
                  </button>
                </div>
              )}

              {/* {achamanForDate.length > 0 && (
                <div className="calendar-achaman">
                  <button
                    className="calendar-achaman-label"
                    style={{
                      background: "#e6e6fa",
                      color: "#4b0082",
                      border: "1px solid #d1c4e9",
                      borderRadius: "6px",
                      padding: "2px 8px",
                      cursor: "pointer",
                      fontSize: "0.95em",
                      marginTop: "4px",
                      width: "100%",
                      textAlign: "left",
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                      position: "relative",
                    }}
                    onClick={() => setAchamanModal({ all: achamanForDate })}
                  >
                    {achamanForDate[0].title.length > 30
                      ? achamanForDate[0].title.slice(0, 30) + "..."
                      : achamanForDate[0].title}
                    {achamanForDate.length > 1 && (
                      <span
                        style={{
                          background: "#b39ddb",
                          color: "#4b0082",
                          borderRadius: "10px",
                          fontSize: "0.8em",
                          padding: "2px 7px",
                          marginLeft: "8px",
                          position: "absolute",
                          right: "1px",
                          top: "1px",
                        }}
                      >
                        {achamanForDate.length}
                      </span>
                    )}
                  </button>
                </div>
              )} */}

              {/*end div*/}
            </div>
          )}
        </div>,
      );
    }

    return days;
  };

  if (loading) {
    return (
      <div className="page-container">
        <div className="loading">Loading Calendar...</div>
      </div>
    );
  }

  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Hindu Calendar 2026</h1>
        <p>
          Complete Hindu Calendar with Tithi, Festivals, and Auspicious Days
        </p>
      </div>
      <div className="calendar-container">
        {/* Month Navigation */}
        <div className="month-navigation">
          <button
            onClick={() =>
              setSelectedMonth((prev) => (prev > 1 ? prev - 1 : 12))
            }
            className="nav-button"
          >
            &#8249;
          </button>

          <div className="month-year">
            <h2>
              {monthNames[selectedMonth - 1]} {selectedYear}
            </h2>
          </div>

          <button
            onClick={() =>
              setSelectedMonth((prev) => (prev < 12 ? prev + 1 : 1))
            }
            className="nav-button"
          >
            &#8250;
          </button>
        </div>

        {/* Month Selector */}
        <div className="month-selector">
          {monthNames.map((month, index) => (
            <button
              key={month}
              onClick={() => setSelectedMonth(index + 1)}
              className={`month-button ${selectedMonth === index + 1 ? "active" : ""}`}
            >
              {month.substring(0, 3)}
            </button>
          ))}
        </div>

        {/* Calendar Grid */}
        <div className="calendar-grid">
          {/* Day Headers */}
          {dayNames.map((day) => (
            <div key={day} className="day-header">
              {day}
            </div>
          ))}

          {/* Calendar Days */}
          {renderCalendarDays()}
        </div>

        {/* Calendar Help */}
        <div className="calendar-legend">
          <h3>Calendar Help</h3>
          <p className="legend-help-text">
            Select any highlighted item in a date to view its details.
          </p>
          <div className="legend-items">
            <div className="legend-item">
              <span className="legend-color legend-public-holiday"></span>
              <span>Public Holiday</span>
            </div>
            <div className="legend-item">
              <span className="legend-color legend-hari-festival"></span>
              <span>Hariprabodham Festival</span>
            </div>
            <div className="legend-item">
              <span className="legend-color legend-ekadashi"></span>
              <span>Ekadashi</span>
            </div>
            <div className="legend-item">
              <span className="legend-color legend-festival"></span>
              <span>Other Festival</span>
            </div>
            <div className="legend-item">
              <span className="legend-color legend-prasang"></span>
              <span>Prasang</span>
            </div>
            <div className="legend-item">
              <span className="legend-color legend-video">▶</span>
              <span>Video</span>
            </div>
            <div className="legend-item">
              <span className="legend-color legend-quote"></span>
              <span>Quote</span>
            </div>
            <div className="legend-item">
              <span className="legend-color legend-pravachan"></span>
              <span>Pravachan</span>
            </div>
          </div>
        </div>
      </div>
      {/* Vicharan detail modal temporarily disabled
      {selectedVicharanDate && (
        <div
          className="modal-overlay"
          onClick={() => setSelectedVicharanDate(null)}
        >
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>
                Vicharan Details - {selectedVicharanDate.date}/
                {selectedVicharanDate.month}/2026
              </h3>
              <button
                className="modal-close"
                onClick={() => setSelectedVicharanDate(null)}
              >
                ×
              </button>
            </div>
            <div className="modal-body">
              {selectedVicharanDate.data.map((vicharan, index) => (
                <div key={vicharan.infoid} className="vicharan-entry">
                  {selectedVicharanDate.data.length > 1 && (
                    <h4 className="vicharan-entry-title">Entry {index + 1}</h4>
                  )}
                  <div className="vicharan-detail">
                    <strong>Date:</strong>{" "}
                    {vicharan.infodate?.date
                      ? new Date(vicharan.infodate.date).toLocaleDateString(
                          "en-GB",
                        )
                      : `${vicharan.infoday}/${vicharan.infomonth}/${vicharan.infoyear}`}
                  </div>
                  <div className="vicharan-detail">
                    <strong>Place:</strong> {vicharan.place}
                  </div>
                  <div className="vicharan-detail">
                    <strong>Description:</strong>
                    <p className="vicharan-description">
                      {vicharan.shortdescguj}
                    </p>
                  </div>
                  {vicharan.videourl && (
                    <div className="vicharan-detail">
                      <strong>Video:</strong>
                      <a
                        href={vicharan.videourl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="vicharan-video-link"
                      >
                        Watch Video
                      </a>
                    </div>
                  )}
                  {index < selectedVicharanDate.data.length - 1 && (
                    <hr className="vicharan-separator" />
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      )} */}
      {/* Prasang Details Modal */}
      {selectedPrasangDate && (
        <div
          className="modal-overlay prasang-modal-overlay"
          onClick={() => {
            setSelectedPrasangDate(null);
            setSelectedPrasangIndex(0);
          }}
        >
          <div
            className="modal-content prasang-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-header prasang-modal-header">
              <h3>
                Prasang Details - {selectedPrasangDate.date}/
                {selectedPrasangDate.month}/2026
              </h3>
              <button
                className="modal-close"
                aria-label="Close Prasang details"
                onClick={() => {
                  setSelectedPrasangDate(null);
                  setSelectedPrasangIndex(0);
                }}
              >
                ×
              </button>
            </div>
            <div className="modal-body prasang-modal-body">
              {selectedPrasangDate.data.length > 1 && (
                <div className="prasang-slide-navigation">
                  <button
                    onClick={() =>
                      setSelectedPrasangIndex((index) => Math.max(index - 1, 0))
                    }
                    disabled={selectedPrasangIndex === 0}
                    className="prasang-slide-button"
                    aria-label="Previous Prasang"
                  >
                    &#8249;
                  </button>
                  <span>
                    {selectedPrasangIndex + 1} /{" "}
                    {selectedPrasangDate.data.length}
                  </span>
                  <button
                    onClick={() =>
                      setSelectedPrasangIndex((index) =>
                        Math.min(
                          index + 1,
                          selectedPrasangDate.data.length - 1,
                        ),
                      )
                    }
                    disabled={
                      selectedPrasangIndex ===
                      selectedPrasangDate.data.length - 1
                    }
                    className="prasang-slide-button"
                    aria-label="Next Prasang"
                  >
                    &#8250;
                  </button>
                </div>
              )}
              {selectedPrasangDate.data[selectedPrasangIndex] && (
                <article className="prasang-slide-article">
                  <h3 className="prasang-title-main">
                    {selectedPrasangDate.data[selectedPrasangIndex].title}
                  </h3>
                  <iframe
                    src={`${process.env.PUBLIC_URL}/data/prasang/${selectedPrasangDate.data[selectedPrasangIndex].file}`}
                    title={selectedPrasangDate.data[selectedPrasangIndex].title}
                    className="prasang-slide-frame"
                    onLoad={(event) => {
                      event.currentTarget.contentDocument?.documentElement.classList.add(
                        "calendar-embed",
                      );
                    }}
                    sandbox="allow-same-origin"
                  />
                </article>
              )}
            </div>
          </div>
        </div>
      )}
      {/* Video Modal */}
      {isVideoModalOpen && (
        <VideoModal
          videoId={selectedVideoId}
          title={selectedVideoTitle}
          isOpen={isVideoModalOpen}
          onClose={closeVideoModal}
        />
      )}
      {/* Quote Modal */}
      {selectedQuote && (
        <div
          className="modal-overlay calendar-detail-modal-overlay"
          onClick={() => setSelectedQuote(null)}
        >
          <div
            className="modal-content calendar-detail-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-header calendar-detail-modal-header">
              <h3>Quotes ({selectedQuote.all.length})</h3>
              <button
                className="modal-close"
                aria-label="Close Quotes"
                onClick={() => setSelectedQuote(null)}
              >
                ×
              </button>
            </div>
            <div className="modal-body calendar-detail-modal-body">
              {selectedQuote.all.map((q, idx) => (
                <div
                  key={q.number || idx}
                  style={{
                    marginBottom: 18,
                    paddingBottom: 8,
                    borderBottom:
                      idx < selectedQuote.all.length - 1
                        ? "1px solid #eee"
                        : "none",
                  }}
                >
                  <div style={{ marginBottom: 6 }}>
                    <strong>Date:</strong> {q.englishdate || "-"}
                  </div>
                  <div style={{ marginBottom: 6 }}>
                    <strong>Quote:</strong>
                    <div style={{ marginTop: 4, fontStyle: "italic" }}>
                      {q.quote}
                    </div>
                  </div>
                  {q.guru && (
                    <div style={{ marginBottom: 6 }}>
                      <strong>- </strong> {q.guru}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
      {selectedPravachan && (
        <div
          className="modal-overlay calendar-detail-modal-overlay"
          onClick={() => setSelectedPravachan(null)}
        >
          <div
            className="modal-content calendar-detail-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-header calendar-detail-modal-header">
              <h3>
                Pravachan Details
                {selectedPravachan.all.length > 1 && (
                  <> ({selectedPravachan.all.length})</>
                )}
              </h3>
              <button
                className="modal-close"
                aria-label="Close Pravachan details"
                onClick={() => setSelectedPravachan(null)}
              >
                ×
              </button>
            </div>
            <div className="modal-body calendar-detail-modal-body">
              {selectedPravachan.all.map((pravachan, index) => (
                <div
                  key={pravachan.PrvDate + pravachan.PrvTitle + index}
                  className="pravachan-entry"
                >
                  {selectedPravachan.all.length > 1 && (
                    <h4 className="pravachan-entry-title">Entry {index + 1}</h4>
                  )}
                  <div className="pravachan-detail">
                    <strong>Date:</strong> {pravachan.PrvDate}
                  </div>
                  <div className="pravachan-detail">
                    <strong>Title:</strong> {pravachan.PrvTitle}
                  </div>
                  <div className="pravachan-detail">
                    <strong>Info:</strong>
                    <p className="pravachan-description">{pravachan.PrvInfo}</p>
                  </div>
                  {index < selectedPravachan.all.length - 1 && (
                    <hr className="pravachan-separator" />
                  )}
                </div>
              ))}
            </div>
            <div
              style={{
                marginTop: 16,
                color: "#388e3c",
                fontWeight: "bold",
                textAlign: "center",
              }}
            >
              To read Pravachan use Paramrut App
              <br />
              <img
                src="/image/paramrut.jpg"
                alt="Paramrut App"
                style={{
                  marginTop: 8,
                  width: 48,
                  height: 48,
                  borderRadius: 8,
                  boxShadow: "0 2px 8px #ccc",
                  display: "block",
                  marginLeft: "auto",
                  marginRight: "auto",
                }}
              />
            </div>
          </div>
        </div>
      )}

      {/* {achamanModal && (
        <div className="modal-backdrop" onClick={closeAchamanModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Achaman Details ({achamanModal.all.length})</h3>
              <button className="modal-close" onClick={closeAchamanModal}>
                ×
              </button>
            </div>
            <div className="modal-body">
              {achamanModal.all.map((item, idx) => (
                <div
                  key={item.id}
                  style={{
                    marginBottom: 18,
                    paddingBottom: 8,
                    borderBottom:
                      idx < achamanModal.all.length - 1
                        ? "1px solid #eee"
                        : "none",
                  }}
                >
                  <div style={{ marginBottom: 6 }}>
                    <strong>Date:</strong> {item.date}
                  </div>
                  <div style={{ marginBottom: 6 }}>
                    <strong>Title:</strong> {item.title}
                  </div>
                  <div style={{ marginBottom: 6 }}>
                    <strong>Content:</strong>
                    <div style={{ marginTop: 4, whiteSpace: "pre-line" }}>
                      {item.content}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )} */}

      {/* main div closing tag */}
    </div>
  );
}

export default Calendar2026;
